export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('page:finish', async (a) => {
    const pageContentContainer = document?.querySelector('.layout__content');

    pageContentContainer?.scrollTo({
      top: 0,
    });
  });
});
